IREP.Managers = (function () {
    var type = '';
    var access = '';
    var country = '';

    var init = function () {


        videojs("video_1").ready(function () {
            this.on("play", function () {
                IREP.track("GMDMVideo", "started", 'GMDMVideoStart', '', '');
            });

            this.on("loadstart", function () {
                IREP.track("GMDMVideo", "started", 'GMDMVideoStart', '', '');

            });

            this.on("ended", function () {
                IREP.track("GMDMVideo", "ended", 'GMDMVideoEnd', '', '');
                $("#thanksCopy").show();

            });
        });

        $("#loginSubmit").on("click", function () {
            login();
        });

        $(".createaccount").on("click", function () {
            access = 'registration'
            $("#steplogin").hide();
            $("#stepcreate").show();
        });

        $(".registerswic").on("click", function () {
            access = 'registration'
            $("#steplogin").hide();
            $("#stepcreate").show();
        });

        $("#registerSubmit").on("click", function () {
            
            if (validRegistration()) {
                register();
            }
        });

        $(".backToLogin").on("click", function () {
            window.location = window.location;
        });

        $("#state").on("change", function () {
            if (ticketCheck()) {
                $("#tickets").show();
            } else {
                $("#tickets").hide();
            }
        });

        $("#storeLocation").on("change", function () {
            GetStores();
        });

        $("#emailAddress").on("blur", function () {
            $.ajax({
                type: "POST",
                url: "https://retailedge.intel.com/ws/registration.asmx/CheckEmailAddress",
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify({ email: document.getElementById("emailAddress").value }),
                dataType: "json",
                dataFilter: function (msg) {
                    msg = eval('(' + msg + ')');
                    if (msg.hasOwnProperty('d'))
                        return msg.d;
                    else
                        return msg;
                },
                success: function (msg) {
                  
                    if (msg.Exists == true) {
                        $(".alreadyExists").show();
                        $("#registerSubmit").hide();
                    } else {
                        $(".alreadyExists").hide();
                        $("#registerSubmit").show();
                    }
                }
            });
            
        });

        GetStoreChains();
    };


    var GetCountryCode = (function () {
        var state = document.getElementById("state").value;

        var nonUS = [61,62,63,64,65,66,67,68,69,70,71,72,73]

        for (var i = 0; i < nonUS.length; i++) {
            if (nonUS[i] == state) {
                return 'CA';
            }
        }

        return 'US';
    });


    
   

    var GetStoreChains = (function () {
        IREP.callApi({
            url: "managerprofile/storechains",
            type: "GET",
        }).done(function (d) {
            $("#storeLocation").append("<option value='0'>Please select</option>");
            $.each(d.chains, function (index, item) {
                $("#storeLocation").append( 
                    $("<option></option>") 
                        .text(item.name)
                        .val(item.id)
                );
            });
        });
    });


    var GetStores = (function () {
        IREP.callApi({
            url: "managerprofile/stores",
            type: "GET",
            data: {StoreChainId: document.getElementById("storeLocation").value}
        }).done(function (d) {
            $("#stores").show();
            $("#stores option").remove(); // Remove all <option> child tags.

            $("#stores").append("<option value='0'>Please select</option>");
            $.each(d.stores, function (index, item) { 
                $("#stores").append( 
                    $("<option></option>") 
                        .text(item.name)
                        .val(item.id)
                );
            });
        });
    });



    return {
        init: init
    }
})();


IREP.SWIC9S3ManagerEarlyRegistration = (function () {

    var SWIC9S3ManagerEarlyRegistration = function () {
        var self = this;

        $("#footer").remove();
        $("#earlyRegistration").show();

        $("input[name='position']").change(function () {
            if ($("#positionGM:checked").length > 0) {
                $(".showAu").hide();
                $("#preferedContact").show();
            } else {
                $(".thanksGM").hide();
            }

            if ($("#positionDM:checked").length > 0) {
                $(".showAu").hide();
                $("#preferedContact").show();
            } else {
                $(".thanksDM").hide();
            }

            if ($("#positionAU:checked").length > 0) {
                $(".showAu").show();
                $("#preferedContact").hide();
            } else {
                $(".thanksAU").hide();
            }

        });


        //IREP.callApi({
        //    url: "SWIC9S3/managerinfo",
        //    type: "GET"
        //}).done(function (d) {
        //    if (!d.info) {


        //    } else {
        //        if (d.info.position == "GM") {
        //            disableForGM();

        //            $("#positionGM").attr("checked", true);
        //        } else if (d.info.position == "DM") {
        //            disableForDM();
        //            $("#positionDM").attr("checked", true);
        //            $("#thanksDM").show();
        //        } else if (d.info.position == "AU") {
        //            disableForAU();

        //            $("#positionAU").attr("checked", true);
        //        }

        //    }
        //});


        $("#managerInfoSubmit").on("click", function () {
            if (self.validateRegistration() == true) {
                $("#registrationStep").hide();
                self.submitManagerInfo();

                if ($("#positionGM:checked").length > 0) {
                    self.disableForGM();
                    $("#thanksGM").show();
                    $(".thanksGM").show();
                    $(".removeMe").hide();
                } else if ($("#positionDM:checked").length > 0) {
                    self.disableForDM();
                    $("#thanksDM").show();
                    $(".thanksDM").show();
                    $(".removeMe").hide();
                } else if ($("#positionAU:checked").length > 0) {
                    self.disableForAU();
                    $(".thanksAU").show();
                    $(".removeMe").hide();

                }
            }

        });


        $("#storeLocation").on("change", function () {
            self.getStores();
            $(".terms").attr("href", "swicterms?retailer=" + document.getElementById("storeLocation").value);
        });


        self.getStoreChains();
    };

    SWIC9S3ManagerEarlyRegistration.prototype.getPosition = function () {
        if ($("#positionGM:checked").length > 0) {
            return "GM";
        } else if ($("#positionDM:checked").length > 0) {
            return "DM";
        } else if ($("#positionAU:checked").length > 0) {
            return "AU";
        } else {
            return "";
        }
    };

    SWIC9S3ManagerEarlyRegistration.prototype.getStoreChains = (function () {
        IREP.callApi({
            url: "managerprofile/storechains",
            type: "GET",
        }).done(function (d) {
            $("#storeLocation").append("<option value='0'>Please select</option>");
            $.each(d.chains, function (index, item) {
                $("#storeLocation").append(
                    $("<option></option>")
                        .text(item.name)
                        .val(item.id)
                );
            });
        });
    });


    SWIC9S3ManagerEarlyRegistration.prototype.getStores = (function () {
        IREP.callApi({
            url: "managerprofile/stores",
            type: "GET",
            data: { StoreChainId: document.getElementById("storeLocation").value }
        }).done(function (d) {
            $("#stores").show();
            $("#stores option").remove(); // Remove all <option> child tags.

            $("#stores").append("<option value='0'>Please select</option>");
            $.each(d.stores, function (index, item) {
                $("#stores").append(
                    $("<option></option>")
                        .text(item.name)
                        .val(item.id)
                );
            });
        });
    });

    var $selected = "";
    //show text field for option selected
    $('#preferedContact').change(function () {

        if ($('#preferedContact').find(":selected").text() == 'Phone') {
            $selected = "phone";
            $("#preferPhone").show();
            $("#preferEmail").hide();
            $("#preferedContact").removeClass("required");
        } else if ($('#preferedContact').find(":selected").text() == 'E-mail') {
            $selected = "e-mail";
            $("#preferPhone").hide();
            $("#preferEmail").show();
            $("#preferedContact").removeClass("required");
        }

    });

    function validateEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    SWIC9S3ManagerEarlyRegistration.prototype.validateRegistration = function () {
        var phoneno = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
        var errors = 0;
        var rg = /\w+([-+.'\w]+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/gi;

        if (document.getElementById("email").value.match(rg) == null) {
            errors += 1;
            document.getElementById("email").style.border = "solid 1px red";
        } else {
            document.getElementById("email").style.border = "";
        }

        if (document.getElementById("firstname").value == "") {
            errors += 1;
            document.getElementById("firstname").style.border = "solid 1px red";
        } else {
            document.getElementById("firstname").style.border = "";
        }

        if (document.getElementById("lastname").value == "") {
            errors += 1;
            document.getElementById("lastname").style.border = "solid 1px red";
        } else {
            document.getElementById("lastname").style.border = "";
        }

        if (document.getElementById("storeLocation").value == 0 || document.getElementById("storeLocation").value == "") {
            errors += 1;
            document.getElementById("storeLocation").style.border = "solid 1px red";
        } else {
            document.getElementById("storeLocation").style.border = "";
        }

        if (document.getElementById("stores").value == 0 || document.getElementById("stores").value == "") {
            errors += 1;
            document.getElementById("stores").style.border = "solid 1px red";
        } else {
            document.getElementById("stores").style.border = "";
        }

        if ($("#positionGM:checked").length > 0) {
            if ($selected == "") {
                errors += 1;

                document.getElementById("selectContact").style.border = "solid 1px red";
            }
            document.getElementById("errorPosition").style.display = "none";
        } else if ($("#positionAU:checked").length > 0) {
            if (document.getElementById("managerEmail").value.match(rg) == null) {
                errors += 1;
                document.getElementById("managerEmail").style.border = "solid 1px red";
            } else {
                document.getElementById("managerEmail").style.border = "";
            }

            if (document.getElementById("managerName").value == "") {
                errors += 1;
                document.getElementById("managerName").style.border = "solid 1px red";
            } else {
                document.getElementById("managerName").style.border = "";
            }
            if (document.getElementById("auManagerPosition").value == 0) {
                errors += 1;
                document.getElementById("auManagerPosition").style.border = "solid 1px red";
            } else {
                document.getElementById("auManagerPosition").style.border = "";
            }
            document.getElementById("errorPosition").style.display = "none";
        } else if ($("#positionDM:checked").length > 0) {
            if ($selected == "") {
                errors += 1;

                document.getElementById("selectContact").style.border = "solid 1px red";
            }
            document.getElementById("errorPosition").style.display = "none";
        } else {
            errors += 1;
            document.getElementById("errorPosition").style.display = "block";
        }
        if (($selected == "phone") && !($("#preferPhone").val().match(phoneno))) {
            errors += 1;

            document.getElementById("preferPhone").style.border = "solid 1px red";
        } else if (($selected == "e-mail") && (!validateEmail($("#preferEmail").val()))) {
            errors += 1;
            document.getElementById("preferEmail").style.border = "solid 1px red";
        }


        if (errors > 0) {
            return false;
        } else {
            return true;
        }
    };

    SWIC9S3ManagerEarlyRegistration.prototype.disableForGM = function () {
        var self = this;
        $("#positionDM").parent().remove();
        $("#positionAU").parent().remove();


        $("#preferedContact").show();
    };

    SWIC9S3ManagerEarlyRegistration.prototype.disableForDM = function () {
        var self = this;
        $("#positionAU").parent().remove();
        $("#positionGM").parent().remove();


        $("#preferedContact").show();
    };

    SWIC9S3ManagerEarlyRegistration.prototype.disableForAU = function () {
        var self = this;
        $("#positionDM").parent().remove();
        $("#positionGM").parent().remove();
        $("#managerName, #managerEmail").attr("disabled", true);
        $("#managerInfoSubmit").hide();

        $("#thanksAU").show();
        $(".thanksAU").show();

    };

    SWIC9S3ManagerEarlyRegistration.prototype.submitManagerInfo = function () {
        var self = this;

        IREP.callApi({
            url: "SWIC9S3/externalmanagerinfo",
            type: "POST",
            data: {
                storeid: document.getElementById("stores").value,
                firstName: document.getElementById("firstname").value,
                lastName: document.getElementById("lastname").value,
                email: document.getElementById("email").value,
                position: self.getPosition(),
                managerName: document.getElementById("managerName").value,
                managerEmail: document.getElementById("managerEmail").value,
                preferemail: document.getElementById("preferEmail").value,
                preferphone: document.getElementById("preferPhone").value,
                auManagerPosition: document.getElementById("auManagerPosition").value
            }
        }).done();

    };



    return SWIC9S3ManagerEarlyRegistration;
}());


IREP.ManagerRegistration = (function () {

    var ManagerRegistration = function () {
        var self = this;

        $("#stepCreate").show();

        $("#registerSubmit").on("click", function () {

            if (self.validRegistration()) {
                self.register();
            }
        });

        $("#storeLocation").on("change", function () {
            self.getStores();
        });

        $("#emailAddress").on("blur", function () {
            $.ajax({
                type: "POST",
                url: "https://retailedge.intel.com/ws/registration.asmx/CheckEmailAddress",
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify({ email: document.getElementById("emailAddress").value }),
                dataType: "json",
                dataFilter: function (msg) {
                    msg = eval('(' + msg + ')');
                    if (msg.hasOwnProperty('d'))
                        return msg.d;
                    else
                        return msg;
                },
                success: function (msg) {

                    if (msg.Exists == true) {
                        $(".alreadyExists").show();
                        $("#registerSubmit").hide();
                        $('#emailAddress').val('');
                    } else {
                        $(".alreadyExists").hide();
                        $("#registerSubmit").show();
                    }
                }
            });

        });

        self.getStoreChains();
    };

    ManagerRegistration.prototype.validRegistration = (function () {
        var errors = 0;
        var self = this;

        if (document.getElementById("shippingAddress").value == "") {
            errors += 1;
            document.getElementById("shippingAddress").style.border = "solid 1px red";
        } else {
            document.getElementById("shippingAddress").style.border = "";
        }

        if (document.getElementById("city").value == "") {
            errors += 1;
            document.getElementById("city").style.border = "solid 1px red";
        } else {
            document.getElementById("city").style.border = "";
        }

        if (document.getElementById("state").value == 0) {
            errors += 1;
            document.getElementById("state").style.border = "solid 1px red";
        } else {
            document.getElementById("state").style.border = "";
        }

        if (document.getElementById("zipCode").value == "") {
            errors += 1;
            document.getElementById("zipCode").style.border = "solid 1px red";
        } else {
            document.getElementById("zipCode").style.border = "";
        }

        if (document.getElementById("emailAddress").value == "") {
            errors += 1;
            document.getElementById("emailAddress").style.border = "solid 1px red";
        } else {
            document.getElementById("emailAddress").style.border = "";
        }

        var rg = /\w+([-+.'\w]+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/gi;

        if (document.getElementById("emailAddress").value.match(rg) == null) {
            errors += 1;
            document.getElementById("emailAddress").style.border = "solid 1px red";
            $("#emailReq").show();
        } else {
            document.getElementById("emailAddress").style.border = "";
            $("#emailReq").hide();
        }


        if (document.getElementById("firstName").value == "") {
            errors += 1;
            document.getElementById("firstName").style.border = "solid 1px red";
        } else {
            document.getElementById("firstName").style.border = "";
        }

        if (document.getElementById("lastName").value == "") {
            errors += 1;
            document.getElementById("lastName").style.border = "solid 1px red";
        } else {
            document.getElementById("lastName").style.border = "";
        }

        if ((document.getElementById("phoneNumber").value == "") || (document.getElementById("phoneNumber").value.length <= 9)) {
            errors += 1;
            document.getElementById("phoneNumber").style.border = "solid 1px red";
        } else {
            document.getElementById("phoneNumber").style.border = "";
        }

        //if (document.getElementById("password").value != document.getElementById("confirmPassword").value) {
        //    errors += 1;
        //    document.getElementById("password").style.border = "solid 1px red";
        //    document.getElementById("confirmPassword").style.border = "solid 1px red";
        //} else {
        //    document.getElementById("password").style.border = "";
        //    document.getElementById("confirmPassword").style.border = "";
        //}

        if (document.getElementById("password").value == "" || document.getElementById("password").value != document.getElementById("confirmPassword").value) {
            errors += 1;
            document.getElementById("password").style.border = "solid 1px red";
        } else {
            document.getElementById("password").style.border = "";
            if (!self.checkPassword()) {
                $("#passwordReq").show();
                document.getElementById("password").style.border = "solid 1px red";
                errors += 1;
            } else {
                $("#passwordReq").hide();
                document.getElementById("password").style.border = "";
            }
        }

        if (document.getElementById("confirmPassword").value == "" || document.getElementById("password").value != document.getElementById("confirmPassword").value) {
            errors += 1;
            document.getElementById("confirmPassword").style.border = "solid 1px red";
        } else {
            document.getElementById("confirmPassword").style.border = "";
        }


        if (document.getElementById("jobTitle").value == 0) {
            errors += 1;
            document.getElementById("jobTitle").style.border = "solid 1px red";
        } else {
            document.getElementById("jobTitle").style.border = "";
        }

        if (!document.getElementById("terms").checked) {
            errors += 1;
            document.getElementById("terms").style.border = "solid 1px red";
        } else {
            document.getElementById("terms").style.border = "";
        }

        if (document.getElementById("storeLocation").value == 0 || document.getElementById("storeLocation").value == "") {
            errors += 1;
            document.getElementById("storeLocation").style.border = "solid 1px red";
        } else {
            document.getElementById("storeLocation").style.border = "";
        }

        if (document.getElementById("stores").value == 0 || document.getElementById("stores").value == "") {
            errors += 1;
            document.getElementById("stores").style.border = "solid 1px red";
        } else {
            document.getElementById("stores").style.border = "";
        }

        if (errors != 0) {
            return false;
        } else {
            return true;
        }


    });


    

    ManagerRegistration.prototype.getStoreChains = (function () {
        IREP.callApi({
            url: "managerprofile/storechains",
            type: "GET",
        }).done(function (d) {
            $("#storeLocation").append("<option value='0'>Please select</option>");
            $.each(d.chains, function (index, item) {
                $("#storeLocation").append(
                    $("<option></option>")
                        .text(item.name)
                        .val(item.id)
                );
            });
        });
    });


    ManagerRegistration.prototype.getStores = (function () {
        IREP.callApi({
            url: "managerprofile/stores",
            type: "GET",
            data: { StoreChainId: document.getElementById("storeLocation").value }
        }).done(function (d) {
            $("#stores").show();
            $("#stores option").remove(); // Remove all <option> child tags.

            $("#stores").append("<option value='0'>Please select</option>");
            $.each(d.stores, function (index, item) {
                $("#stores").append(
                    $("<option></option>")
                        .text(item.name)
                        .val(item.id)
                );
            });
        });
    });



    ManagerRegistration.prototype.getCountryCode = (function () {
        var state = document.getElementById("state").value;

        var nonUS = [61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73]

        for (var i = 0; i < nonUS.length; i++) {
            if (nonUS[i] == state) {
                return 'CA';
            }
        }

        return 'US';
    });

    return ManagerRegistration;
})();